import { render } from "./SommarioConsumiFornitori.vue?vue&type=template&id=d83a55a6&scoped=true"
import script from "./SommarioConsumiFornitori.vue?vue&type=script&lang=js"
export * from "./SommarioConsumiFornitori.vue?vue&type=script&lang=js"

import "./SommarioConsumiFornitori.vue?vue&type=style&index=0&id=d83a55a6&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83a55a6"]])

export default __exports__